export default __webpack_public_path__ + "static/input-text-28d827e7804a8affd821b65931a7c132.png";